import { Checkbox as MUICheckbox, FormControlLabel, Typography } from '@mui/material';

interface CheckboxProps {
  value: boolean;
  onCheck: (checked: boolean) => void;
  label?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ value, onCheck, label }) => {
  return (
    <FormControlLabel
      control={
        <MUICheckbox checked={value} onChange={(e) => onCheck(e.target.checked)} color="primary" />
      }
      label={
        <Typography fontSize={'15px'} fontWeight={900} color={'#226AAA'}>
          {label}
        </Typography>
      }
    />
  );
};
